export const makeBlankSpec = () => ({
  elementName: '',
  partNumber: '',
  currentCurrent: '',
  current: '',
  wattage: '',
  voltage: '',
  lengths: '',
});
